
(() => {
'use strict';
const SB='https://xlqqqklbfzxduqqmbnxd.supabase.co';
const KEY='sb_publishable_0Ti6F0HzOJSBj8OS9lsmvQ_sQBSzeWJ';
const SK='seven_supabase_session_v32';
const q=s=>document.querySelector(s);
const session=()=>{try{return JSON.parse(localStorage.getItem(SK)||'null')}catch(e){return null}};

async function getProfile(){
  const s=session();
  if(!s?.access_token||!s?.user?.id)return null;
  try{
    const r=await fetch(SB+'/rest/v1/seven_profiles?id=eq.'+encodeURIComponent(s.user.id)+'&select=*',{
      cache:'no-store',
      headers:{apikey:KEY,Authorization:'Bearer '+s.access_token,Accept:'application/json'}
    });
    if(!r.ok)return null;
    const d=await r.json();
    return d?.[0]||null;
  }catch(e){return null}
}

async function refreshIdentity(){
  if(new URLSearchParams(location.search).get('seven_member')!=='1')return;
  const p=await getProfile();
  const s=session();
  if(!p)return;
  const explicit=String(p.first_name||p.firstname||p.prenom||'').trim();
  const full=String(p.name||p.full_name||'').trim();
  const fallback=full?full.split(/\s+/)[0]:String(p.email||s?.user?.email||'SEVEN MEMBER').split('@')[0];
  const first=(explicit||fallback||'SEVEN MEMBER').trim();
  const ident=q('[data-seven-member-identity]');
  const avatar=q('[data-seven-member-head-avatar]');
  if(ident)ident.textContent=first.toUpperCase();
  if(avatar)avatar.textContent=first.charAt(0).toUpperCase();
}

async function realLogout(e){
  e?.preventDefault();
  e?.stopImmediatePropagation();
  const s=session();
  try{
    if(s?.access_token){
      await fetch(SB+'/auth/v1/logout',{
        method:'POST',
        headers:{apikey:KEY,Authorization:'Bearer '+s.access_token}
      });
    }
  }catch(err){}
  localStorage.removeItem(SK);
  localStorage.removeItem('seven_founder_app_role');
  sessionStorage.clear();
  location.replace('/');
}

document.addEventListener('DOMContentLoaded',()=>{
  setTimeout(refreshIdentity,180);
  const logout=q('[data-seven-member-logout]');
  if(logout)logout.addEventListener('click',realLogout,true);
});
})();
